import DateTimePicker from "@/components/DateTimePicker/dateTimePicker.component";
import {
  format,
  isPast,
  isThisYear,
  isToday,
  isTomorrow,
  isYesterday,
  parseISO,
} from "date-fns";
import React, { MutableRefObject, ReactNode } from "react";

type TimerCellDateTimeProps = {
  time: string;
  className: string;
  editedTime?: string;
  editing: boolean;
  isOpen?: MutableRefObject<boolean>;
  handleEditField?: (value: string) => void;
};

const TimerCellDateTime: React.FC<TimerCellDateTimeProps> = ({
  time,
  className,
  editedTime,
  editing,
  handleEditField,
  isOpen,
}) => {
  const handleFieldDateTime = (date: Date | undefined | null) => {
    if (handleEditField) {
      handleEditField(date?.toISOString() || "");
    }
  };

  function formatCellDate(date: string | null): ReactNode {
    try {
      if (!date) return <div className="">No End Time</div>;

      const parsedDate = parseISO(date);
      let dateShown;
      let colorClass = "";
      if (isToday(parsedDate)) {
        colorClass = "text-green-400";
        dateShown = `Today ${format(parsedDate, "HH:mm:ss")}`;
      } else if (isTomorrow(parsedDate)) {
        colorClass = "text-indigo-400";
        dateShown = `Tomorrow ${format(parsedDate, "HH:mm:ss")}`;
      } else if (isPast(parsedDate)) {
        if (isYesterday(parsedDate)) {
          dateShown = `Yesterday ${format(parsedDate, "HH:mm:ss")}`;
        }
      }

      if (isThisYear(parsedDate)) {
        dateShown = dateShown ?? format(parsedDate, "yyy/MM/dd HH:mm:ss");
      } else {
        dateShown = dateShown ?? format(parsedDate, "yyy/MM/dd HH:mm:ss");
      }

      return <div className={`${colorClass}`}>{dateShown}</div>;
    } catch (error) {
      console.error("Error formatting date:", error);
      console.log("Date string:", date);
      return <div className="">Invalid Date</div>;
    }
  }

  return time && editing && handleEditField ? (
    <div className={className}>
      <DateTimePicker
        dateTime={editedTime ? new Date(editedTime) : null}
        onDateTimeChange={handleFieldDateTime}
        modal={false}
        createDateTimeOpen={isOpen}
      />
    </div>
  ) : (
    <div className={className}>{formatCellDate(time)}</div>
  );
};

export default TimerCellDateTime;
